import { render } from "./LoadData.vue?vue&type=template&id=3e3bf56d"
import script from "./LoadData.vue?vue&type=script&lang=js"
export * from "./LoadData.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/front/intranet-gpaie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__